import { numberWithCommas } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const Points = (props) => {
  const { item } = props;
  const { t } = useLocalization();

  if (item.itemData?.loyaltyPoints) {
    return (
      <>
        <span className="c7-price--loyalty-points">
          <span>+</span>
          {numberWithCommas(item.itemData.loyaltyPoints)}{' '}
          {t('general.loyalty.points')}
        </span>
      </>
    );
  }
  return null;
};

export default Points;
